import React, { Component } from "react";
import { Navigate } from "react-router-dom";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginParams: {
        user_id: "",
        user_password: ""
      },
      error: ""
    };
  }

  handleFormChange = event => {
    let loginParamsNew = { ...this.state.loginParams };
    let val = event.target.value;
    loginParamsNew[event.target.name] = val;
    this.setState({
      loginParams: loginParamsNew
    });
  };

  login = event => {
    event.preventDefault();
    let user_id = this.state.loginParams.user_id;
    let user_password = this.state.loginParams.user_password;
    // Note: this is a placeholder login for keeping the upload page off of
    // random visitors, not real authentication. See testing-and-validation.md
    // if this needs to become a real, server-checked login.
    if (user_id === "admin" && user_password === "123") {
      localStorage.setItem("token", "T");
      this.forceUpdate();
    } else {
      this.setState({ error: "Incorrect username or password." });
    }
  };

  render() {
    if (localStorage.getItem("token")) {
      return <Navigate to="/upload" />;
    }
    return (
      <div className="admin-login">
        <form onSubmit={this.login} className="form-signin">
          <h2>Admin Sign In</h2>
          <div className="form-signin-fields">
            <input
              type="text"
              name="user_id"
              onChange={this.handleFormChange}
              placeholder="Username"
              autoComplete="username"
            />
            <input
              type="password"
              name="user_password"
              onChange={this.handleFormChange}
              placeholder="Password"
              autoComplete="current-password"
            />
            {this.state.error && (
              <p className="form-signin-error">{this.state.error}</p>
            )}
            <input type="submit" value="Login" />
          </div>
        </form>
      </div>
    );
  }
}
export default Login;
